import {Button, DialogActions, DialogContent} from '@material-ui/core';
import accountApi from 'Agent/Accounts/api/accountApi';
import {AccountDetail} from 'Agent/Accounts/models/AccountDetail';
import React from 'react';
import Modal from 'Shared/components/Modal';
import withSelectedAgency, {WithSelectedAgencyProps} from 'Shared/components/withSelectedAgency';
import {UserClaims} from 'Users/models/Claims';
import {createSnackbar} from 'Core/ducks/snackbar';
import {useDispatch} from 'react-redux';

type RequestPolicyInfoReportModalProps = {
  onClose: () => void;
  userClaims: UserClaims;
  accountDetail: AccountDetail;
  email: string;
} & WithSelectedAgencyProps;

const RequestPolicyInfoReportModal = (props: RequestPolicyInfoReportModalProps) => {
  const dispatch = useDispatch();
  const requestReport = () => {
    accountApi.requestReport(
      props.accountDetail.number!,
      props.userClaims.id,
      props.email,
      props.accountDetail.source!.id!.toString(),
      props.selectedAgency.encryptedIdentifier
    );
  };

  return (
    <Modal title="Request Policy Information Report" open onClose={props.onClose}>
      <div className="card__dialog">
        <DialogContent>Are you sure you want to generate a policy information report for this account?</DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              requestReport();
              props.onClose();
              dispatch(createSnackbar('Generating report...'));
            }}
            color="primary"
          >
            Request Report
          </Button>
          <Button onClick={props.onClose}>Cancel</Button>
        </DialogActions>
      </div>
    </Modal>
  );
};

export default withSelectedAgency(RequestPolicyInfoReportModal);
